
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getEventList } from '@/api/orderPolling';

@Component({
  name: 'selectPolling',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogSelectEventVisible!:Boolean;

  private formSearchEvent = {
    name: '',
    checkname: ''
  }
  private datalistEvent:any = []
  private selectEvent: any = ''
  private pageQuery = {
    pageCurrent: 1,
    pageSize: 10
  }
  private moreLoading = false

  created() {
    this.getEventList();
  }

  private tableRowChildSection() {
    return 'bgColor';
  }
  private search() {
    this.pageQuery.pageCurrent = 1;
    this.selectEvent = '';
    this.getEventList();
  }
  private reset() {
    this.formSearchEvent = { name: '',
      checkname: '' };
    this.pageQuery.pageCurrent = 1;
    this.getEventList();
  }
  // 选择自定义事件
  private getEventList() {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.page = this.pageQuery.pageCurrent;
    parmars.size = this.pageQuery.pageSize;
    parmars.event_name = this.formSearchEvent.name;
    parmars.check_name = this.formSearchEvent.checkname;
    getEventList(parmars).then(res => {
      if (res.data && res.data.page_count > 1 && res.data.page_current < res.data.page_count) {
        this.moreLoading = true;
      } else {
        this.moreLoading = false;
      }

      if (res.data) {
        if (this.pageQuery.pageCurrent === 1) {
          this.datalistEvent = res.data.list;
        } else {
          this.datalistEvent = this.datalistEvent.concat(res.data.list);
        }
      } else {
        this.datalistEvent = [];
      }
    }).catch(err => {
      let msg = err;
    });
  }

  private loadMore() {
    this.pageQuery.pageCurrent++;
    this.getEventList();
  }

  private selectEventFinsh() {
    if (this.selectEvent === '') {
      this.$notify({
        title: '提示',
        message: '请选择自定义事件',
        offset: 100,
        type: 'error'
      });
      return;
    }
    this.$emit('selectEvent', this.selectEvent);
    this.close();
  }

  private close() {
    this.$emit('close', false);
  }
}

